import { render, staticRenderFns } from "./fixturesList.vue?vue&type=template&id=68d6f660&"
import script from "./fixturesList.vue?vue&type=script&lang=js&"
export * from "./fixturesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports